export const CONTACTS = {
  instagramUrl: 'https://www.instagram.com/totemnotes/',
  viber: '+380636796327',
  telegram: '+380636796327',
  phoneNumber: '+380636796327',
  email: 'totemnotes@gmail.com'
};
